<app-side-menu>
  <div class="ipva-licensing-container">
    <div class="row mb-4">
      <div class="col-12">
        <div class="page-header">
          <div class="d-flex align-items-center">
            <div>
              <h1 class="page-title">
                <i class="fas fa-file-invoice-dollar me-3"></i>
                IPVA e Licenciamento
              </h1>
              <p class="page-subtitle">Consulte as pendências da frota e realize pagamentos</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="ipva-licensing-card">
      <div class="bank-provider-info" *ngIf="bankProvider">
        <span class="badge bg-secondary me-2">Provedor: {{ bankProvider.providerName }}</span>
        <span *ngIf="!bankProvider.isAvailable" class="text-muted small">
          Integração bancária não ativa. Use "Registrar pagamento manual" para lançar pagamentos.
        </span>
      </div>

      <div class="filters-section">
        <div class="filters-row">
          <div class="filter-group">
            <label for="vehicleFilter" class="form-label">Filtrar por Veículo:</label>
            <select id="vehicleFilter" class="form-select" [(ngModel)]="filterVehicleId" (change)="onFilterChange()">
              <option [ngValue]="null">Todos os veículos</option>
              <option *ngFor="let v of vehicles" [ngValue]="v.id">
                {{ v.plateNumber }} — {{ v.brand }} {{ v.model }}
              </option>
            </select>
          </div>
          <div class="filter-group">
            <label for="typeFilter" class="form-label">Filtrar por Tipo:</label>
            <select id="typeFilter" class="form-select" [(ngModel)]="filterType" (change)="onFilterChange()">
              <option value="">Todos</option>
              <option value="IPVA">IPVA</option>
              <option value="Licenciamento">Licenciamento</option>
            </select>
          </div>
          <div class="filter-group">
            <label for="yearFilter" class="form-label">Filtrar por Ano:</label>
            <select id="yearFilter" class="form-select" [(ngModel)]="filterYear" (change)="onFilterChange()">
              <option [ngValue]="null">Todos</option>
              <option *ngFor="let y of currentYears" [ngValue]="y">{{ y }}</option>
            </select>
          </div>
          <div class="filter-actions">
            <button type="button" class="btn btn-outline-secondary" (click)="clearFilters()">
              <i class="fas fa-times me-2"></i>
              Limpar Filtros
            </button>
            <button type="button" class="btn btn-success ms-2" (click)="openModalBank()" *ngIf="bankProvider?.isAvailable">
              <i class="fas fa-university me-2"></i>
              Pagar via banco
            </button>
            <button type="button" class="btn btn-primary ms-2" (click)="openModalManual()">
              <i class="fas fa-edit me-2"></i>
              Registrar pagamento manual
            </button>
          </div>
        </div>
      </div>

      <div *ngIf="error" class="alert alert-danger" role="alert">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <i class="fas fa-exclamation-triangle me-2"></i>
            {{ error }}
          </div>
          <button type="button" class="btn btn-outline-danger btn-sm" (click)="retryLoad()">
            <i class="fas fa-redo me-1"></i>
            Tentar Novamente
          </button>
        </div>
      </div>

<div *ngIf="!loading && !error && getFilteredData().length > 0" class="table-content">
        <app-table
          [title]="tableTitle"
          [columns]="columns"
          [data]="getFilteredData()"
          [loading]="loading"
          [showSearch]="showSearch"
          [searchPlaceholder]="searchPlaceholder"
          [clickable]="clickable"
          [actions]="actions"
          [enableSorting]="true"
          [clientSideSort]="true"
          (rowClick)="onActionClick({ action: 'view', item: $event })"
          (actionClick)="onActionClick($event)">
        </app-table>
      </div>

      <div *ngIf="!loading && !error && getFilteredData().length === 0" class="empty-state">
        <i class="fas fa-file-invoice-dollar"></i>
        <h3>Nenhuma pendência encontrada</h3>
        <p>Não há IPVA ou Licenciamento pendente no momento, ou os filtros não retornaram resultados.</p>
        <button type="button" class="btn btn-outline-secondary mt-2" (click)="clearFilters()">
          Limpar filtros
        </button>
      </div>
    </div>
  </div>
</app-side-menu>

<!-- Modal Pagar via banco -->
<app-modal [isOpen]="showModalBank" title="Pagar via banco" size="md" (close)="closeModalBank()">
  <div *ngIf="bankSuccessMessage" class="alert alert-success">
    {{ bankSuccessMessage }}
    <a *ngIf="boletoUrl" [href]="boletoUrl" target="_blank" rel="noopener" class="alert-link ms-2">Abrir boleto</a>
  </div>
  <form *ngIf="!bankSuccessMessage" (ngSubmit)="submitBank()">
    <div class="mb-3">
      <label class="form-label">Veículo</label>
      <select class="form-select" [(ngModel)]="formBank.vehicleId" name="vehicleId" required>
        <option [ngValue]="0">Selecione o veículo</option>
        <option *ngFor="let v of vehicles" [ngValue]="v.id">{{ v.plateNumber }} — {{ v.brand }} {{ v.model }}</option>
      </select>
    </div>
    <div class="mb-3">
      <label class="form-label">Tipo</label>
      <select class="form-select" [(ngModel)]="formBank.paymentType" name="paymentType">
        <option value="IPVA">IPVA</option>
        <option value="Licenciamento">Licenciamento</option>
      </select>
    </div>
    <div class="mb-3">
      <label class="form-label">Ano de referência</label>
      <select class="form-select" [(ngModel)]="formBank.referenceYear" name="referenceYear">
        <option *ngFor="let y of currentYears" [ngValue]="y">{{ y }}</option>
      </select>
    </div>
    <div class="mb-3">
      <label class="form-label">Valor (R$)</label>
      <input type="number" step="0.01" class="form-control" [(ngModel)]="formBank.amount" name="amount" required />
    </div>
    <div class="mb-3">
      <label class="form-label">Número do documento</label>
      <input type="text" class="form-control" [(ngModel)]="formBank.documentNumber" name="documentNumber" />
    </div>
    <div class="mb-3">
      <label class="form-label">Observações</label>
      <textarea class="form-control" [(ngModel)]="formBank.notes" name="notes" rows="2"></textarea>
    </div>
  </form>
  <div slot="footer" *ngIf="!bankSuccessMessage">
    <button type="button" class="btn btn-outline-secondary" (click)="closeModalBank()">Fechar</button>
    <button type="button" class="btn btn-success ms-2" (click)="submitBank()" [disabled]="submittingBank">
      <span *ngIf="submittingBank" class="spinner-border spinner-border-sm me-1"></span>
      Solicitar pagamento
    </button>
  </div>
  <div slot="footer" *ngIf="bankSuccessMessage">
    <button type="button" class="btn btn-primary" (click)="closeModalBank()">Fechar</button>
  </div>
</app-modal>

<!-- Modal Registrar pagamento manual -->
<app-modal [isOpen]="showModalManual" title="Registrar pagamento manual" size="md" (close)="closeModalManual()">
  <form (ngSubmit)="submitManual()">
    <div class="mb-3">
      <label class="form-label">Veículo</label>
      <select class="form-select" [(ngModel)]="formManual.vehicleId" name="vehicleId" required>
        <option [ngValue]="0">Selecione o veículo</option>
        <option *ngFor="let v of vehicles" [ngValue]="v.id">{{ v.plateNumber }} — {{ v.brand }} {{ v.model }}</option>
      </select>
    </div>
    <div class="mb-3">
      <label class="form-label">Tipo</label>
      <select class="form-select" [(ngModel)]="formManual.paymentType" name="paymentType">
        <option value="IPVA">IPVA</option>
        <option value="Licenciamento">Licenciamento</option>
      </select>
    </div>
    <div class="mb-3">
      <label class="form-label">Ano de referência</label>
      <select class="form-select" [(ngModel)]="formManual.referenceYear" name="referenceYear">
        <option *ngFor="let y of currentYears" [ngValue]="y">{{ y }}</option>
      </select>
    </div>
    <div class="mb-3">
      <label class="form-label">Valor (R$)</label>
      <input type="number" step="0.01" class="form-control" [(ngModel)]="formManual.amount" name="amount" required />
    </div>
    <div class="mb-3">
      <label class="form-label">Data do pagamento</label>
      <input type="date" class="form-control" [(ngModel)]="formManual.paymentDate" name="paymentDate" required />
    </div>
    <div class="mb-3">
      <label class="form-label">Número do documento / guia</label>
      <input type="text" class="form-control" [(ngModel)]="formManual.documentNumber" name="documentNumber" />
    </div>
    <div class="mb-3">
      <label class="form-label">Observações</label>
      <textarea class="form-control" [(ngModel)]="formManual.notes" name="notes" rows="2"></textarea>
    </div>
  </form>
  <div slot="footer">
    <button type="button" class="btn btn-outline-secondary" (click)="closeModalManual()">Cancelar</button>
    <button type="button" class="btn btn-primary ms-2" (click)="submitManual()" [disabled]="submittingManual">
      <span *ngIf="submittingManual" class="spinner-border spinner-border-sm me-1"></span>
      Registrar
    </button>
  </div>
</app-modal>
